<template>
    <div class="card mb-3" v-if="recipe_yield !== ''">
        <div class="card-body">
            <h4 class="card-title">Yield</h4>
            <p class="card-text">
                {{ recipe_yield }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "RecipeYield",
    props: ["recipe"],
    data() {
        return {
            recipe_yield: this.recipe.yield,
        };
    },
};
</script>
<style scoped></style>
